import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { CycleRowWrapper } from './styles';
import { prettyStandingsUrl } from '../../common/rcs_gaz_mc_core_FE';
import Label from '../../components/shared/Label';
import LabelLink from '../../components/shared/LabelLink';
import IconFont from '../../components/shared/IconFont';
import * as status from '../../constants';
import { extractData } from '../../containers/CycleCalendar/utils/customCyclingConfig';


const difficultyWrapper = (competitionId, race) => {
  const difficultyRatio = extractData('difficulty', competitionId, race);
  if (difficultyRatio === undefined) return null;
  return (
    <div>
      <Label
        label="Difficoltà:"
        size={0.8}
        //color={cycleStage.get('status') === status.INPROGRESS ? 'liveColor' : 'black'}
        //size={isMobile ? 0.8 : 0.9}
      />
      {Array.from({ length: difficultyRatio }).map((_, index) => (
        <IconFont
          key={index}
          className="icon-matchcenter-star"
          color="black"
          font={10}
          weight="bold"
          withCursor
          opacity="1 !important"
        />
      ))}
    </div>);
};

const CycleRow = ({
  cycleStage, isMobile, tappa, isCustomRace,
}) => {
  const { competitionId } = window.matchcenterPage;

  const formatDate = (datePassed) => {
    const dateJs = datePassed.split('-');
    const month = dateJs[1];
    const dayOfMonth = dateJs[0];
    return `${dayOfMonth}/${month}`;
  };
  const winnerName = () => {
    const playerName = cycleStage.getIn(['winner', 'playerName']);
    if (playerName && playerName !== '') {
      return `${playerName}`;
    }
    return '-';
  };
  const magliaRosaName = () => {
    const playerName = cycleStage.getIn(['leaderJersey', 'playerName']);
    if (playerName && playerName !== '') {
      return playerName;
    }
    return '-';
  };
  return (
    <CycleRowWrapper
      href={`${prettyStandingsUrl(window.matchcenterPage.sportId, window.matchcenterPage.competitionId, process.env.REACT_APP_SITE, true)}tappa/${tappa}/`}
      activeTappa={cycleStage.get('status') === 'COMPLETE'}
      isMobile={isMobile}
      isCustomRace={isCustomRace}
    >
      {cycleStage &&
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col lg={1} md={2} sm={2} style={{ paddingLeft: '10px', paddingRight: '5px' }}>
          <Label
            label={formatDate(cycleStage.get('date'))}
            color={cycleStage.get('status') === status.INPROGRESS ? 'liveColor' : 'black'}
            size={0.8}
          />
        </Col>
        {!isMobile &&
          <Col lg={1.5} md={isCustomRace ? 2 : 1.5} sm={isCustomRace ? 2 : 1.5} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
            <Label
              label={`${cycleStage.get('raceId')}°`}
              color={cycleStage.get('status') === status.INPROGRESS ? 'liveColor' : 'black'}
              size={0.8}
            />
          </Col>
        }
        <Col
          lg={isCustomRace ? 3 : 4}
          md={isCustomRace ? 4.5 : 5}
          sm={isCustomRace ? 4.5 : 5}
          style={{
            paddingLeft: '5px',
            paddingRight: '5px',
            display: 'flex',
            justifyContent: 'flex-start',
            textAlign: 'left',
            overflow: 'visible',
            flexDirection: isCustomRace ? 'column' : 'row',
            alignItems: isCustomRace ? 'flex-start' : 'center',
        }}
        >{isCustomRace ?
          <LabelLink
            enableArrow={false}
            path={extractData('url', competitionId, cycleStage.get('raceId'))}
            label={cycleStage.get('raceName')}
            color={cycleStage.get('status') === status.INPROGRESS ? 'liveColor' : 'black'}
            size={isMobile ? 0.8 : 0.9}
            alignSelf="flex-start"
            forcePointer
          /> :
          <Label
            label={cycleStage.get('raceName')}
            color={cycleStage.get('status') === status.INPROGRESS ? 'liveColor' : 'black'}
            size={isMobile ? 0.8 : 0.9}
            alignSelf="flex-start"
          />
        }
          {isCustomRace &&
            difficultyWrapper(competitionId, cycleStage.get('raceId'))}
          {isCustomRace && isMobile && magliaRosaName() !== '-' &&
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Label
              label="Maglia Rosa:"
              size={0.8}
              margin="5px 0 0 0"
              alignSelf="flex-start"
            />
            <Label
              label={`${magliaRosaName()}`}
              size={0.8}
              weight="bold"
              margin="5px 0 0 0"
              alignSelf="flex-start"
            />
          </div> }
        </Col>
        {!isMobile &&
        <Col lg={1} md={1} sm={1} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
          <Label
            label={`${cycleStage.get('raceLength').slice(0, -2).replace('.', ',')} km`}
            size={isMobile ? 0.8 : 0.9}
          />
        </Col>
        }
        <Col lg={isCustomRace ? 2.5 : 4} md={isCustomRace ? 4.5 : 4} sm={isCustomRace ? 4.5 : 4} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
          <Label
            label={winnerName()}
            weight="bold"
            size={isMobile ? 0.8 : 0.9}
          />
        </Col>

        {isCustomRace && !isMobile &&
        <Col lg={2.5} md={2} sm={2.5} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
          <Label
            label={magliaRosaName()}
            weight="bold"
            size={isMobile ? 0.8 : 0.9}
          />
        </Col>
        }
        <Col lg={0.5} md={1} sm={1} style={{ paddingLeft: '5px', paddingRight: '10px' }}>
          <IconFont
            className="icon-matchcenter-right-arrow"
            color={isCustomRace ? 'black' : 'linkColor'}
            font={18}
            weight="bold"
            size={isMobile ? 0.8 : 0.9}
            withCursor
          />
        </Col>
      </Row>
      }
    </CycleRowWrapper>
  );
};

CycleRow.propTypes = {
  cycleStage: PropTypes.any,
  isMobile: PropTypes.bool,
  tappa: PropTypes.number,
  isCustomRace: PropTypes.bool,
};

export default CycleRow;



// WEBPACK FOOTER //
// ./src/components/CycleRow/index.js